import { useEffect, useState } from 'react';

/**
 * Hook that returns a boolean indicating if the current viewport matches the provided media query
 * @param query - CSS media query string (e.g. '(max-width: 640px)')
 * @returns boolean indicating if the viewport matches the query
 */
const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    // Set initial value
    const mediaQuery = window.matchMedia(query);
    setMatches(mediaQuery.matches);

    // Define event handler
    const handler = (event: MediaQueryListEvent) => setMatches(event.matches);

    // Add event listener
    mediaQuery.addEventListener('change', handler);

    // Clean up
    return () => mediaQuery.removeEventListener('change', handler);
  }, [query]);

  return matches;
};

export default useMediaQuery;
